import { array, number } from 'prop-types'
import { css } from '@emotion/react'

import { userLogOut } from '@/store/user'
import { isAuthorized as isUserAuthorized } from '@/store/selectors'
import mediaQueries from '@/layout/media-queries'
import { useTypedDispatch, useTypedSelector } from '@/store/hooks'

import SignUpButton from '../SignUpButton'
import LogInButton from '../LogInButton'
import User from './User'

const accountWrapperCss = css`
  display: none;

  ${mediaQueries.smallScreen()} {
    display: block;
  }
`

const buttonsWrapperCss = css`
  width: 236px;
  display: flex;

  > a {
    margin-left: 15px;
  }
`

const Account = ({ menuItems, leftPosition }) => {
  const dispatch = useTypedDispatch()
  const isAuthorized = useTypedSelector(isUserAuthorized)

  const logOutHandler = () => {
    dispatch(userLogOut.pending())
  }

  return (
    <div css={accountWrapperCss}>
      {isAuthorized ? (
        <User
          logOut={logOutHandler}
          menuItems={menuItems}
          leftPosition={leftPosition}
        />
      ) : (
        <div css={buttonsWrapperCss}>
          <LogInButton />
          <SignUpButton />
        </div>
      )}
    </div>
  )
}

Account.propTypes = {
  menuItems: array,
  leftPosition: number,
}

export default Account
